import { regular, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'
import { Alert, Badge, Button, Card, Col, Container, Form, ListGroup, Modal, OverlayTrigger, Row, Stack, Tooltip } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
// import { useNavigate } from 'react-router-dom';
import { Tasks } from '../../api/Tasks';
import AppLoader from '../../components/AppLoader';
import AppSearch from '../../components/AppSearch';
import IconButton from '../../components/IconButton';
import { useFullScreenLoader } from '../../contexts/fullScreenLoader';
import { useToasts } from '../../contexts/toasts';
import { Task } from '../../models/Task';
import { useNavigate } from 'react-router-dom';
import { format, parseISO } from 'date-fns';

export default function TasksList() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [tasks, setTasks] = useState<Task[] | null>();

  const [taskToDelete, setTaskToDelete] = useState<Task>();
  const [taskDetail, setTaskDetail] = useState<Task>();
  const [searchText, setSearchText] = useState<string>("");
  const [alphaSort, setAlphaSort] = useState<number>(-1);
  const [updatedSort, setUpdatedSort] = useState<number>(-1);

  const [validated, setValidated] = useState<boolean>(false);
  const [showDetailModal, setShowDetailModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);

  const { showLoader, hideLoader } = useFullScreenLoader();
  const { showToast } = useToasts();



  useEffect(() => {
    initTasks();
    // eslint-disable-next-line
  }, []);

  const handleDeleteModalClose = () => setShowDeleteModal(false);

  const handleDetailModalClose = () => {
    setShowDetailModal(false);
    setValidated(false);
  }

  const openDeleteModal = (task: Task) => {
    setShowDeleteModal(true);
    setTaskToDelete(task);
  }
  const openDetailModal = (task: Task) => {
    setShowDetailModal(true);
    setTaskDetail(task);
  }

  const reset = () => {
    setTasks(null);
    initTasks();
  }


  const handleSearchChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const value = evt.target.value;
    setSearchText(value);
  }

  const deleteTask = () => {
    showLoader!();

    Tasks.deleteTask(taskToDelete!.id!)
      .then(
        () => {
          hideLoader!();
          showToast!('task-success', 'Task deleted successfully', 'Delete Success', 'success');
          handleDeleteModalClose();
          reset();
        },
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          hideLoader!();
          showToast!('Task-error', message, `Tasks Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }

  const editTask = (id: number) => () => navigate(`/tasks/${id}/edit`);


  const initTasks = () => {
    Tasks.getTasks()
      .then(
        ({ data: tasks }) => setTasks(tasks),
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          hideLoader!();
          showToast!('task-error', message, `Tasks Error ${status ? `(${status})` : ''}`, 'danger');
        }
      );
  }


  const activateSort = (type: 'alpha' | 'updated') => {
    const sort = {
      'alpha': () => setAlphaSort(alphaSort === 1 ? -1 : alphaSort + 1),
      'updated': () => setUpdatedSort(updatedSort === 1 ? -1 : updatedSort + 1)
    }
    sort[type]();
  }

  function compareForSort(a: any, b: any) {
    if (a < b) {
      return -1
    }
    if (a > b) {
      return 1
    }
    return 0;
  }

  const renderTasks = () => {
    const filteredTasks = tasks!.filter(task => task.name.toLowerCase().includes(searchText.toLowerCase())).sort((a, b) => {
      let result;
      alphaSort < 0 ? result = 0 : alphaSort > 0 ? result = compareForSort(a.name, b.name) : result = compareForSort(b.name, a.name)
      return result;
    }).sort((a, b) => {
      let result;
      updatedSort < 0 ? result = 0 : updatedSort > 0 ? result = compareForSort(a.updatedAt, b.updatedAt) : result = compareForSort(b.updatedAt, a.updatedAt)
      return result;
    })


    return (
      <>
        <Row className="gx-2 mb-3">
          <Col md={11}>
            <AppSearch value={searchText} onChange={handleSearchChange} placeholder={t('tasksList.search')} />
          </Col>
          <Col>

            <OverlayTrigger placement={"top"} overlay={<Tooltip id={`tooltip-alphaSort`}>Sort by alphabetical order</Tooltip>}>
              <span>
                <IconButton className={alphaSort > -1 ? "text-primary" : ""} onClick={() => activateSort('alpha')} >
                  <FontAwesomeIcon className="me-1" icon={alphaSort < 0 ? solid('sort') : alphaSort > 0 ? solid('sort-up') : solid('sort-down')} />
                  <div className='d-flex flex-column'>
                    <FontAwesomeIcon size='2xs' icon={solid('a')} />
                    <FontAwesomeIcon size='2xs' icon={solid('z')} />
                  </div>
                </IconButton>
              </span>
            </OverlayTrigger>

            <OverlayTrigger placement={"top"} overlay={<Tooltip id={`tooltip-updateSort`}>Sort by update date </Tooltip>}>
              <span>
                <IconButton className={updatedSort > -1 ? "text-primary" : ""} onClick={() => activateSort('updated')}>
                  <FontAwesomeIcon className="me-1" icon={updatedSort < 0 ? solid('sort') : updatedSort > 0 ? solid('sort-up') : solid('sort-down')} />
                  <FontAwesomeIcon icon={solid('clock-rotate-left')} />
                </IconButton>
              </span>
            </OverlayTrigger>

          </Col>
        </Row>

        {filteredTasks.length === 0 && (
          <Alert className="mb-0 py-2">
            <FontAwesomeIcon icon={solid('info-circle')} />
            <span className="ms-2">{t('tasksList.noTasks')}</span>
          </Alert>
        )}

        <ListGroup>
          <ListGroup.Item key="0" className="align-items-center">
            <Row>
              <Col md={4} className="">Tasks</Col>
              <Col md={3} className="ps-0">Created At:</Col>
              <Col md={3} className="ps-0">Updated At:</Col>
              <Col md={2} className="text-end">Actions</Col>
            </Row>
          </ListGroup.Item>

          {filteredTasks.map((task, index) => (
            <ListGroup.Item key={task.id} className="d-flex align-items-center">
              <Col md={4} className='overflow-hidden d-flex align-items-center'>
                <div className="pe-3">
                  <FontAwesomeIcon icon={regular('check-circle')} size="lg" fixedWidth />
                </div>

                <Col className="overflow-hidden">
                  <h6 className="mb-0 highlight" onClick={() => openDetailModal(task)}>{task.name}</h6>
                  <p className="text-truncate mb-0 pe-3">{task.description}</p>
                </Col>
              </Col>
              <Col md={3}>
                {task.createdAt &&
                  <Badge bg="light" text="dark" className="border justify-self-end">
                    <span className="">{task.createdAt ? format(parseISO(task.createdAt!), 'dd/MM/yyyy HH:mm') : ''}</span>
                  </Badge>
                }
              </Col>

              <Col md={3}>
                <Badge bg="light" text="dark" className="border justify-self-end">
                  <span className="">{format(parseISO(task.updatedAt!), 'dd/MM/yyyy HH:mm')}</span>
                </Badge>
              </Col>

              <div className="ps-3 text-end">
                <IconButton className="ms-2" onClick={editTask(task.id!)}>
                  <FontAwesomeIcon icon={solid('pen')} />
                </IconButton>
                <IconButton className="ms-2" onClick={() => openDeleteModal(task)}>
                  <FontAwesomeIcon className="text-danger" icon={solid('trash')} />
                </IconButton>
              </div>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </>
    )
  }

  const renderAsyncContent = () => {
    return tasks
      ? renderTasks()
      : (
        <div className="d-flex justify-content-center py-5">
          <AppLoader size={150} />
        </div>
      )
  }

  return (
    <Container>
      <Card>
        <div className="d-flex align-items-center justify-content-between border-bottom py-2 px-3">
          <Card.Title className="mb-0">{t('tasksList.title')}</Card.Title>

          <Button variant="success" size="sm" onClick={() => { navigate("/tasks/create") }}>
            <FontAwesomeIcon icon={solid('plus')} />
            <span className="ms-2">{t('tasksList.create')}</span>
          </Button>
        </div>

        <Card.Body>{renderAsyncContent()}</Card.Body>
      </Card>

      <Modal show={showDeleteModal} onHide={handleDeleteModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t('common.deleteTitle', { item: t('common.task') })}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {t('tasksList.deleteMessage')} <b>{taskToDelete?.name}</b>?

          <h5 className="my-4 text-center text-danger">{t('common.deleteWarning')}</h5>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="light" className="border" size="sm" onClick={handleDeleteModalClose}>{t('common.cancel')}</Button>
          <Button variant="danger" size="sm" onClick={deleteTask}>{t('common.delete')}</Button>
        </Modal.Footer>
      </Modal>

      <Modal size="lg" show={showDetailModal} onHide={handleDetailModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{`${taskDetail?.name}`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row >
            <Col md={2}>
              <h6 className='mb-0'>Name </h6>
            </Col>
            <Col md={10}>
              <span>{taskDetail?.name}</span>
            </Col>
          </Row>
          <Row >
            <Col md={2}>
              <h6 className='mb-0'>Description </h6>
            </Col>
            <Col md={10}>
              <span>{taskDetail?.description}</span>
            </Col>
          </Row>
          <Row >
            <Col md={2}>
              <h6 className='mb-0'>Type </h6>
            </Col>
            <Col md={10}>
              <span>{taskDetail?.type}</span>
            </Col>
          </Row>
          <Row >
            <Col md={2}>
              <h6 className='mb-0'>Video Url </h6>
            </Col>
            <Col md={10}>
              <a className='highlight' href={taskDetail?.videoUrl} target="_blank" rel="noopener noreferrer">Link</a>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="success" className="border" size="sm" onClick={handleDetailModalClose}>{t('common.ok')}</Button>
        </Modal.Footer>

      </Modal>
    </Container >
  )
}